<template>
    <div class="home">
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="register-ruleForm">
                <el-form-item prop="phone" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.phone" autocomplete="off" placeholder="请输入新手机号"
                        maxlength="11"></el-input>
                </el-form-item>
                <el-form-item prop="captcha" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.captcha" autocomplete="off" placeholder="校验码"
                        maxlength="4"></el-input>
                    <img class="captchaImg" :src="imgsrc"  @click="refreshCaptcha">
                </el-form-item>
                <el-form-item prop="code" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.code" autocomplete="off" placeholder="验证码"
                        maxlength="4"></el-input>
                    <div class="sendBtn" @click="checkCaptchaImg('ruleForm')">{{ second === totalSecond ?
                        '获取验证码' : second + 's后重新发送' }}</div>
                </el-form-item>
            </el-form>
            <div class="all-btn">
                <div class="over-btn" @click="submitForm('ruleForm')">确认</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getIdentifyCode,sendMsgCode, updateStudentPhone } from '@/api/common'   //路径
export default {
    name: 'ResetPhone',
    props: ['id'],
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '' || value.length < 11 || value.substring(0, 1) !== '1') {
                callback(value === '' ? new Error('请输入手机号') : new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        var validateCaptcha = (rule, value, callback) => {
            if (rule.field === 'captcha' && value === '' && this.checkCaptcha === true) {
                callback(new Error('请输入校验码'));
            } else {
                callback();
            }
        };
        return {
            merchantId: '',
            ruleForm: {
                phone: '',
                code: '',
                captcha: '',
            },
            rules: {
                phone: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                captcha: [
                    { validator: validateCaptcha, trigger: 'blur' }
                ],
            },
            imgsrc: '',
            buttonText: '获取验证码',
            checkCaptcha: false,
            totalSecond: 60,//总秒数
            second: 60,//倒计时的秒数
            timer: null // 定时器 id
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.getIdentifyCodeImg();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.reset();
                } else {
                    return false;
                }
            });
        },
        getIdentifyCodeImg() {
            let that = this;
            let params = {};
            getIdentifyCode(params).then((res) => {
                that.imgsrc = 'data:image/png;base64,' + res.imgsrc;
            })
        },
        refreshCaptcha() {
            this.getIdentifyCodeImg();
        },
        checkCaptchaImg(formName) {
            let that = this;
            if(that.second < 60) {
                return;
            }
            let flage = true;
            that.checkCaptcha = true;
            that.$refs[formName].validateField('phone', error => {
                if (error) {
                    flage = false;
                }
            });
            that.$refs[formName].validateField('captcha', error => {
                if (error) {
                    flage = false;
                }
            });
            if (flage) {
                let params = {
                    merchantId: that.merchantId,
                    phone: that.ruleForm.phone,
                    imgCaptcha: that.ruleForm.captcha,
                    type: "2"
                };
                sendMsgCode(params).then((res) => {
                    that.checkCaptcha = false;
                    if (res.code !== 200) {
                        that.getIdentifyCodeImg();
                        that.$message.error(res.msg);
                    } else {
                        that.getCode();
                    }
                })
            } else {
                that.checkCaptcha = false;
            }
        },
        getCode() {
            let that = this;
            if (!that.timer && that.second == that.totalSecond) {
                // 开启倒计时
                that.timer = setInterval(() => {
                    that.second--
                    if (that.second <= 0) {
                        clearInterval(that.timer)
                        that.timer = null // 重置定时器 id
                        that.second = that.totalSecond//归位
                    }
                }, 1000)
                that.$message.success('发送成功,请注意查收')
            }
        },
        reset() {
            let that = this;
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            updateStudentPhone(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    localStorage.setItem('loginPhone', that.ruleForm.phone);
                    that.resetForm("ruleForm");
                    that.$message({
                        duration: 1000,
                        message: '修改成功',//提示的信息
                        type: 'success',//类型是成功
                        onClose: () => {
                            this.$router.push({ name: 'person', params: { id: this.merchantId } });
                        }
                    });
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>
<style scoped>
.content {
    padding: 30px 40px;
}

.input-each-div {
    position: relative;
    display: flex;
    margin-bottom: 15px;
}

.input-each-div:first-child {
    margin-top: 0px;
}

.input-each-div :deep(.el-input__inner) {
    padding: 0;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #E5E5E5;
}

.input-each {
    flex: 1;
    line-height: 20px;
    outline: none;
}

.input-each::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 500;
}

.all-btn {
    margin-top: 40px;
    overflow: hidden;
}

.over-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #0095D9;
    border-radius: 32px;
}

.captchaImg {
    position: absolute;
    width: 70px;
    height: 30px;
    right: 0;
    top: 50%;
    margin-top: -15px;
}

.sendBtn {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -12px;
    min-width: 70px;
    height: 22px;
    line-height: 22px;
    border: 1px solid #666666;
    border-radius: 12px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #666666;
    letter-spacing: 0;
}
</style>